module.exports = __webpack_public_path__ + "img/pm25.d4d106a7.png";